import { Injectable } from "@angular/core";
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { DocumentType, SearchResult, Contract, DocumentTemplate } from '../models/supplier.model';
import { map } from 'rxjs/operators';
import { AppSettings } from "../../app.settings";

@Injectable()
export class SupplierDocumentService extends BaseService {
    private documentTypeArray: DocumentType[];

    constructor(private http: HttpClient, private config: AppSettings) {
        super();
    }

    getDocumentType(reload: boolean = false): Observable<DocumentType[]> {
        if (reload || !this.documentTypeArray) {
            const url = `${this.config.BaseUrl}Profile/Document/Type`;
            return this.http.get<DocumentType[]>(url, { headers: this.setHeaders() })
                .pipe(map((r) => {
                    this.documentTypeArray = r.sort((a, b) => a.name < b.name ? -1 : 1);
                    return this.documentTypeArray;
                }));
        } else {
            return of(this.documentTypeArray);
        }
    }

    getContracts(supplierCode: string): Observable<Contract[]> {
        const url = `${this.config.BaseUrl}Profile/Document/Contracts/${supplierCode}`;
        return this.http.get<SearchResult<Contract>>(url, { headers: this.setHeaders() })
            .pipe(map((r) => {
                return r.rows;
            }));
    }

    getDocumentTemplates(docType: string): Observable<DocumentTemplate[]> {
        const url = `${this.config.BaseUrl}Profile/Document/DocumentTemplates/${docType}`;
        return this.http.get<DocumentTemplate[]>(url, { headers: this.setHeaders() });
    }
}
